import api from "@/services/api.service";

export default {
   name: 'show-conflict',
   components: {},
   props: {
    caption: {
      type: String,
      default: "Duplicate Imported Contact list"
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      contact_data: [],
      fields: [],
      conflict_data:[],  
      levelDiscription : {'ExachMacth':'','UpdateMatch': '','ConflictMatch': '','LikelyMatch': '','LikelyMatchWithConflict': '','PossibleMatch': '','PossibleMatchWithConflict': ''},        
      status:'',
      formField:[],     
      errorClass: 'bg-warning',
      permission_viewConflict: false,
      superAdmin: false
    };
  },
  watch: {},
  async created() {
    let response = await api.post("users/user-permissions");
        const permissions = [];
        if (response.status == "success") {
          response.data[0].permission.forEach( function(element) {                
              permissions.push(element.action)
          }.bind(this));
            if(permissions.includes("view_duplicate_mass_conflict_imported_contact") == true){
              this.getDuplicateImportedContact();
              this.permission_viewConflict = permissions.includes("view_duplicate_mass_conflict_imported_contact");
            }else if(response.data[0].role == 'super_admin'){
              this.getDuplicateImportedContact();
              this.superAdmin = true;
          }else if(permissions.includes("list_duplicate_mass_imported_contact") == true){
              this.makeToast("Permission denied","Alert","warning",6000);
              this.$router.push({name: 'Duplicate Mass Imported Contact List'});
            }else if(permissions.includes("list_duplicate_mass_import_contact") == true || permissions.includes("add_duplicate_mass_import_contact") == true){
              this.makeToast("Permission denied","Alert","warning",6000);
              this.$router.push({name: 'Duplicate Mass Import List'});
            }else{
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Admin Dashboard'});
            }
      } 

  },  
  methods: {
    makeToast(message = "", title = "Alert", variant = "warning") {
    this.toastCount++;
    this.$root.$bvToast.toast(message, {
      title: title,
      variant: variant,
      autoHideDelay: 3000
    });
  },
  async getDuplicateImportedContact() {
    let response = await api.post("admin/duplicate-mass-import/duplicate-imported-contact-list", {id : this.$route.params.conflict_id});          
    if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);
    if (response.status == "success") {
      if (response.data.data != "") {  
        //GET ALL HEADERS FROM JSON        
        var columns = Object.keys(Object.assign({}, ...[JSON.parse(response.data.contact_data)]));        
        columns.map((h) => {
         this.fields.push({key: h})
       });
        this.fields.push({key:'total_score'},{key:'total_waightage'},{key:'total_score_per'},{key:'updates_on'});
        this.status = response.data.status;  
        //Iterate Data
        this.contact_data = JSON.parse(response.data.contact_data);//Object.assign({}, JSON.parse(response.data.contact_data), {id:response.data.id});
        this.formField = JSON.parse(response.data.contact_data);;//Object.assign({}, JSON.parse(response.data.contact_data), {id:response.data.id});
        this.conflict_data = JSON.parse(response.data.conflict_data);
        
      } else {
        this.items = [];
      }
    }      
    this.isBusy = false;
  }, 
   async edit(){
    if(!this.formField.id){        
      this.makeToast('Please select any updateds on column','Validation','danger');
      return;
    }
    this.formField.imported_conflict_id = this.$route.params.conflict_id;
    let response = await api.post('contact/edit-conflict-contact', this.formField);
    if (!response)
      this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

    if (response.status == 'success') {
      this.makeToast(response.message, 'Success', 'success', 6000);
      this.$router.push({name: "Duplicate Mass Imported Contact List",params:{ 'id':this.$route.params.id} });      
    } else {
      for (var error in response.errors) {
        this.makeToast(response.errors[error], 'Alert', 'danger');
      }
    }
  },
  async editNext(){
    if(!this.formField.id){        
      this.makeToast('Please select any updateds on column','Validation','danger');
      return;
    }
    this.formField.imported_conflict_id = this.$route.params.conflict_id;
    let response = await api.post('contact/edit-conflict-contact', this.formField);
    if (!response)
      this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

    if (response.status == 'success') {

        let responseNext = await api.post("admin/import-contact/ediNext",{import_contact_id: this.$route.params.id,response_id:this.$route.params.conflict_id});
        if(responseNext.status=='success'){
          this.makeToast(response.message, 'Success', 'success', 6000);
          return this.$router.push({name : "Duplicate Imported Contact Conflict",params: {conflict_id:responseNext.data.id}});
        } else {
          this.makeToast(response.message, 'Success', 'success', 6000);
          this.makeToast("No response pending to resolve","Alert","warning",6000);
          this.$router.push({name: 'Duplicate Mass Imported Contact List'});
        }
    } 
    else {
      for (var error in response.errors) {
        this.makeToast(response.errors[error], 'Alert', 'danger');
      }
    }
  },
  async keepBoth(){
    this.formField.imported_conflict_id = this.$route.params.conflict_id;
    let response = await api.post('contact/add-conflict-contact', this.formField);
    if (!response)
      this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

    if(response.status=='success'){
      this.makeToast(response.message,'Success','success');
      this.$router.push({ name: "Duplicate Mass Imported Contact List" , params:{'id': this.$route.params.id}});
    }else{
      for(var error in response.errors){
        this.makeToast(response.errors[error],'Alert','danger');
      }
    }
  },async keepBothNext(){
    this.formField.imported_conflict_id = this.$route.params.conflict_id;
    let response = await api.post('contact/add-conflict-contact', this.formField);
    if (!response)
      this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

    if(response.status=='success'){
      let responseNext = await api.post("admin/import-contact/ediNext",{import_contact_id: this.$route.params.id,response_id:this.$route.params.conflict_id});
        if(responseNext.status=='success'){
          this.makeToast(response.message, 'Success', 'success', 6000);
          return this.$router.push({name : "Duplicate Imported Contact Conflict",params: {conflict_id:responseNext.data.id}});
        } else {
          this.makeToast(response.message, 'Success', 'success', 6000);
          this.makeToast("No response pending to resolve","Alert","warning",6000);
          this.$router.push({name: 'Duplicate Mass Imported Contact List'});
        }
    }else{
      for(var error in response.errors){
        this.makeToast(response.errors[error],'Alert','danger');
      }
    }
  }

  }
}


